module.exports = __webpack_public_path__ + "static/media/feetme_rollup_2.1a29fd89.png";